import React, { useEffect, useState, useRef } from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";
import moment from "moment";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Excelldownload = ({ data, data1 }) => {
  let product = "";
  let product_details = "";
  let color = "";
  let size = "";
  return (
    <ExcelFile
      element={
        <Button type="primary" style={{ width: "100%" }}>
          Download
        </Button>
      }
    >
      <ExcelSheet data={data} name="Products Entry Report">
        <ExcelColumn label="Date" value={(col) => {
          return moment(col.created).format("YYYY-MM-DD hh:mm A");
        }} />
        <ExcelColumn label="Supplier" value={(col) => {
          return col.Merchandiser__name;
        }} />
        <ExcelColumn label="Location" value={(col) => {
          return col.ProductLocation.Warehouse_name;
        }} />
        <ExcelColumn label="Product" value={(col) => {
          return col.ProductLocation.title;
        }} />
        <ExcelColumn label="Variation" value={(col) => {
          return col.ProductLocation.Attribute_details;
        }} />
        <ExcelColumn label="Sub category" value={(col) => {
          return col.ProductLocation.category;
        }} />
        <ExcelColumn label="Product Code" value={(col) => {
          return col.ProductLocation.ProductDetails.product_code;
        }} />
        <ExcelColumn label="Costing Price" value={(col) => {
          return col.ProductLocation.purchase_price;
        }} />
        <ExcelColumn label="Selling Price" value={(col) => {
          return col.ProductLocation.selling_price;
        }} />
        <ExcelColumn label="Quantity" value={(col) => {
          return col.quantity;
        }} />
        {/* <ExcelColumn label="Invoice No." value="Invoice_no" />
        <ExcelColumn label="Customer" value="Customer" />
        <ExcelColumn label="Contact" value="Contact" />
        <ExcelColumn label="Category" value="parent_category" />
        <ExcelColumn label="Sub category" value="main_category" />
        <ExcelColumn
          label="Color"
          value={(col) => {
            if (product.length > 1) {
              let color = product_details[0];
              return color;
            }
          }}
        />
        <ExcelColumn label="Quantity" value="quantity" />
        <ExcelColumn label="Price" value="price" /> */}
      </ExcelSheet>
    </ExcelFile>
  );
};

export default Excelldownload;
